import { useEffect, useState } from "react";
import Logo         from "../assets/test.png";
import { HomeBody } from "./home_body";
import { Navigater, Header, ViewWindow, ViewRequest, RequestState, Loading } from "./home_comps";
export const Home = ( props ) => {
    const { } = props;
    const [ color,        setColor        ] = useState("#3f51b5");
    const [ page,         setPage         ] = useState("home"); 
    const [ viewWindow,   setViewWindow   ] = useState(false);
    const [ viewRequest,  setViewRequest  ] = useState(false);
    const [ requestState, setRequestState ] = useState(false);
    const [ loading,      setLoading      ] = useState(true);
    const [ itemId,       setItemId       ] = useState("0");
    useEffect(_=>{
        setTimeout(_=> setLoading(false), 3500);
    }, [loading]);
    return (
        <>
            {/*=====Loading icon=====*/}
            { loading && <Loading image = { Logo } title = { "اليقين للأجهزة الأوربية" }/> }
            {/*=====ViewWindow=====*/}
            { viewWindow   &&
            <ViewWindow
		setItemId       = { setItemId      }
		itemId          = { itemId         }
		setViewWindow   = { setViewWindow  }
		setViewRequest  = { setViewRequest }
            /> }
            {/*=====ViewRequest=====*/}
            { viewRequest  && 
                <ViewRequest 
		    setItemId       = { setItemId       }
		    itemId          = { itemId          }
                    setViewRequest  = { setViewRequest  }
                    setRequestState = { setRequestState }
                    title           = { "تأكيد الطلب"  } 
                />
            }
            {/*=====RequestState=====*/}
            { requestState && 
                <RequestState 
                    setRequestState = { setRequestState } 
                    setViewRequest  = { setViewRequest  } 
                    state           = { true            }
                />
            }
            {/*=====Header=======*/}
            <Header bgColor = { color }/>
            {/*=====HomeBody=====*/}
            <HomeBody 
                page            = { page           }
                setViewWindow   = { setViewWindow  }
                setViewRequest  = { setViewRequest }
                setItemId       = { setItemId      }	    
	        viewWindow      = { viewWindow     }
                viewRequest     = { viewRequest    }
	        itemId          = { itemId         }
            />
            {/*=====Navigater=====*/}
            <Navigater 
                page     = { page     } 
                setPage  = { setPage  } 
                setColor = { setColor }
            />
        </>
    );
};
